import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    Typography,
    Grid,
    InputLabel,
    TextField,
    Card,
    CardActions,
    CardContent,
} from "@material-ui/core";
import axios from "../../api";
import Swal from "sweetalert2";

function EditarUnidade({ id, title, apiUrl, fetchTableData }) {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(null);
    const [tableKey, setTableKey] = useState(0); // add key to table component
    const [formValues, setFormValues] = useState({
        sigla: "",
        descricao: "",
        bairro: "",
        logradouro: "",
        cidade: "",
        rg: "",
        cep: "",
        numero: "",
        ativo: "",
        qtd_funcionarios: "",
    });

    useEffect(() => {
        const fetchUnidade = async () => {
            try {
                const response = await axios.get(apiUrl + id);
                console.log(response.data)
                const { data: unidade } = response.data;
                setData(unidade);
                setFormValues((prevFormValues) => ({
                    ...prevFormValues,
                    sigla: unidade.sigla,
                    descricao: unidade.descricao,
                    logradouro: unidade.logradouro,
                    bairro: unidade.bairro,
                    cidade: unidade.cidade,
                    rg: unidade.rg,
                    cep: unidade.cep,
                    numero: unidade.numero,
                    ativo: unidade.ativo,
                    qtd_funcionarios: unidade.qtd_funcionarios,
                }));
            } catch (error) {
                console.error(error);
            }
        };
        if (open) {
            fetchUnidade();
        }
    }, [open, id, apiUrl]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    const handleUpdate = async () => {
        try {
            console.log(formValues)
            await axios.put(apiUrl + id, formValues);
            Swal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'A unidade foi atualizada com sucesso.',
            });
            // refresh table component by updating its key
            fetchTableData()
            handleClose();
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Erro!',
                text: error.response.data.error,
            });
        }
    };

    return (
        <div>
            <Button variant="contained" id={"edit"} size="small" onClick={handleOpen}>
                <i className="fas fa-pencil"></i> Editar
            </Button>
            <Modal open={open} onClose={handleClose}>
                <div
                    style={{
                        position: "absolute",
                        top: "40%",
                        left: "54%",
                        transform: "translate(-50%, -50%)",
                        width: "70%",
                        backgroundColor: "white",
                    }}
                >

                    <br/>
                    {data && (
                        <Card>
                            <CardContent>
                                <Typography variant="h5">{title}</Typography>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={3}>
                                        <InputLabel style={{ padding: "0.5rem" }}>Sigla</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="sigla"
                                            name="sigla"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.sigla}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    sigla: event.target.value,
                                                })
                                            }

                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{ padding: "0.5rem" }}>Descricao</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="descricao"
                                            name="descricao"
                                            variant="outlined"
                                            placeholder="Descrição"
                                            value={formValues.descricao}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    descricao: event.target.value,
                                                })
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>Bairro</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            value={formValues.bairro}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    bairro: event.target.value,
                                                })
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>Cidade</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            value={formValues.cidade}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    cidade: event.target.value,
                                                })
                                            }

                                        />
                                    </Grid>

                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>logradouro</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.logradouro}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    logradouro: event.target.value,
                                                })
                                            }

                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>CEP</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.cep}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    cep: event.target.value,
                                                })
                                            }

                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>NUmero</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.numero}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    numero: event.target.value,
                                                })
                                            }

                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>Ativo</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.ativo === 1 ? 'Sim' : 'Não'}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    ativo: event.target.value,
                                                })
                                            }
                                        />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <InputLabel style={{padding: '0.5rem'}}>Quantidade Funcionarios</InputLabel>
                                        <TextField

                                            id="outlined-required"
                                            variant="outlined"
                                            placeholder="Nome Funcionário"
                                            value={formValues.qtd_funcionarios}
                                            onChange={(event) =>
                                                setFormValues({
                                                    ...formValues,
                                                    qtd_funcionarios: event.target.value,
                                                })
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            </CardContent>
                            <CardActions>
                                <Button  variant="contained" id="success" type="submit" onClick={handleUpdate}>
                                    <i className="fa-solid fa-plus"></i> Salvar
                                </Button>
                                <Button variant="contained" color="secondary" type="submit" onClick={handleClose}><i
                                    className="fas fa-remove"></i>Cancelar</Button>
                            </CardActions>
                        </Card>
                    )}
                </div>
            </Modal>
        </div>
    );
}

export default EditarUnidade;
